<template>
    <div
        class="col-span-12 border-gray-200 grid grid-cols-7 lg:grid-cols-13 gap-2"
    >
        <div class="flex col-span-7 md:col-span-2 items-center gap-1 md:gap-4">
            <FilterGroupDropdown
                btnLabel="Hotel Brand"
                class="col-span-1"
                :options="groupsFilters"
                labelKey="name"
                origin="search"
                :selected="selectedGroups"
                :showOptionImages="true"
                :isDisabled="noResults"
                valueKey="slug"
                @selectionMade="setGroup"
                @clearSelected="clearGroups"
            />

            <SearchByName
                @handleSelect="handleSelect"
                :isDisabled="noResults"
            />
        </div>
    </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useHotelsStore } from '@/store/hotels';
import { onMounted, computed } from 'vue';
import SearchByName from '@/components/hotels/search/search-by-name/search-by-name.vue';
import FilterGroupDropdown from '@/components/ui/filter-group-dropdown/filter-group-dropdown.vue';
export default {
    components: {
        FilterGroupDropdown,
        SearchByName,
    },
    emits: ['handleSelect'],
    setup(_, { emit }) {
        const hotelsStore = useHotelsStore();
        const { selectedGroups, groupsFilters, filteredSearchResults } =
            storeToRefs(hotelsStore);
        const { setGroups, clearSelectedGroups, applyFilters, setLoading } =
            hotelsStore;

        const setGroup = (value) => {
            setGroups(value, 'property-search');
        };

        const noResults = computed(() => {
            return filteredSearchResults.value?.length === 0;
        });

        const handleSelect = (data) => {
            emit('handleSelect', data);
        };

        const clearGroups = () => {
            setLoading(true);
            clearSelectedGroups();
            applyFilters();
            setTimeout(() => {
                setLoading(false);
            }, 250);
        };

        onMounted(() => {
            clearSelectedGroups();
        });

        return {
            clearGroups,
            groupsFilters,
            handleSelect,
            noResults,
            selectedGroups,
            setGroup,
        };
    },
};
</script>
